/*
 * Copyright (c) 2021-2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: Editor.ts
 * Project: mle-client
 * Committed last: 2021/11/12 @ 847
 * ---
 */

import {ApolloClient, ApolloLink, InMemoryCache} from '@apollo/client';
import {TokenService} from '../ap/token.service';
import {createUploadLink} from 'apollo-upload-client';
import {onError} from '@apollo/client/link/error';
import {MleToaster, Toasts} from '../../common/toast';
import {urlProvider} from "../url/UrlProviderInstanceManager";

/**
 * Consente l'accesso tramite HTTP al server GQL, può essere concatenato ad altri link E.G. WSS
 */
const httpLink = createUploadLink({uri: urlProvider.getDomainUrl()});

/**
 * Invia, tramite header authorization, l'accessToken che consente di autenticare il chiamante
 * @type {ApolloLink}
 */
const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: `Bearer ${ TokenService.getInstance().getAccessToken() }`,
    }
  }));

  return forward(operation);
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  try {
    if (graphQLErrors)
      graphQLErrors.forEach(({ message, locations, path }) => {
        if (message.includes('forbidden') || message.includes('Forbidden'))
          MleToaster.getInstance().show(Toasts.FORBIDDEN);
        else
          MleToaster.getInstance().show(Toasts.GENERIC_ERROR);
      });

    if (networkError) {
      console.log(`[Network error]: ${ networkError }`);
    }
  } catch (e) {}
});


/**
 * Istanza del client HTTP (GQL).
 * Imposta cache con relative opzioni e viene associato ai Link disponibili.
 * @type {ApolloClient<NormalizedCacheObject>}
 */
export const mleDomainGqlClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([errorLink, authMiddleware, httpLink])
});

